class ObstetricalResourcesPostnatalDepressionScale {
    public PostnatalDepressionScaleDate?: Date;
    public AbilityToLaughScore?: number;
    public HopefullnessScore?: number;
    public SelfBlameScore?: number;
    public AnxietyScore?: number;
    public PanicScore?: number;
    public CopingScore?: number;
    public DifficultySleepingScore?: number;
    public SadnessScore?: number;
    public CryingScore?: number;
    public SelfHarmScore?: number;

    constructor(fields?: Partial<ObstetricalResourcesPostnatalDepressionScale>) {
        Object.assign(this, fields);
    }

    public get totalScore(): number {
        if (this.AbilityToLaughScore == null
            && this.HopefullnessScore == null
            && this.SelfBlameScore == null
            && this.AnxietyScore == null
            && this.PanicScore == null
            && this.CopingScore == null
            && this.DifficultySleepingScore == null
            && this.SadnessScore == null
            && this.CryingScore == null
            && this.SelfHarmScore == null)
            return null;

        return (this.AbilityToLaughScore ?? 0)
            + (this.HopefullnessScore ?? 0)
            + (this.SelfBlameScore ?? 0)
            + (this.AnxietyScore ?? 0)
            + (this.PanicScore ?? 0)
            + (this.CopingScore ?? 0)
            + (this.DifficultySleepingScore ?? 0)
            + (this.SadnessScore ?? 0)
            + (this.CryingScore ?? 0)
            + (this.SelfHarmScore ?? 0);
    }
}

export { ObstetricalResourcesPostnatalDepressionScale };
